import getPlayerStoryParams from '@gameday/core/datasources/helpers/getPlayerStoryParams';
import getPOTGVisibility from '../selectors/getPOTGVisibility';
const EMPTY = Object.freeze({});

const potgWinnersDataRequestAction = () => {
    return (dispatch, getState, { componentDataEngine }) => {
        const state = getState();
        const { showPOTG } = getPOTGVisibility(state);

        if (!showPOTG) {
            return Promise.resolve(EMPTY);
        }

        dispatch({
            type: 'potg_loading',
            data: { isLoadingStories: true, isLoadingWinners: true }
        });
        const {
            gumbo: { gamePk },
            config: { language = 'en' }
        } = state;

        return componentDataEngine
            .fetch('potgWinners', { gamePk })
            .then((winnersRes) => {
                const winnerIds = winnersRes.data.winnerIds;
                componentDataEngine.store(winnersRes);
                const params = getPlayerStoryParams(winnerIds);
                componentDataEngine
                    .fetchAndStore('playerStory', { ...params, winnerIds, language })
                    .catch((playerStoryError) =>
                        componentDataEngine.store(playerStoryError)
                    );
            })
            .catch((winnerError) => componentDataEngine.store(winnerError));
    };
};

export default potgWinnersDataRequestAction;
